import { render, staticRenderFns } from "./wageInquiry.vue?vue&type=template&id=6f8daeff&scoped=true"
import script from "./wageInquiry.vue?vue&type=script&lang=js"
export * from "./wageInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8daeff",
  null
  
)

export default component.exports